import { ENV } from "@vrf/fr-vrf-core";
import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";

export const TEMPLATE_FILE_URL =
  "spreadsheet-template/root-component-edit-dialog-pic-address.xlsx";

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;
